
export interface depreciation {
    year: number;
    percent: number;
}

//ค่าเสื่อมประเภทตึก
export const bm_type1: depreciation[] = [
    { year: 1, percent: 1 },
    { year: 2, percent: 2 },
    { year: 3, percent: 3 },
    { year: 4, percent: 4 },
    { year: 5, percent: 5 },
    { year: 6, percent: 6 },
    { year: 7, percent: 7 },
    { year: 8, percent: 8 },
    { year: 9, percent: 9 },
    { year: 10, percent: 10 },
    { year: 11, percent: 12 },
    { year: 12, percent: 14 },
    { year: 13, percent: 16 },
    { year: 14, percent: 18 },
    { year: 15, percent: 20 },
    { year: 16, percent: 22 },
    { year: 17, percent: 24 },
    { year: 18, percent: 26 },
    { year: 19, percent: 28 },
    { year: 20, percent: 30 },
    { year: 21, percent: 32 },
    { year: 22, percent: 34 },
    { year: 23, percent: 36 },
    { year: 24, percent: 38 },
    { year: 25, percent: 40 },
    { year: 26, percent: 42 },
    { year: 27, percent: 44 },
    { year: 28, percent: 46 },
    { year: 29, percent: 48 },
    { year: 30, percent: 50 },
    { year: 31, percent: 52 },
    { year: 32, percent: 54 },
    { year: 33, percent: 56 },
    { year: 34, percent: 58 },
    { year: 35, percent: 60 },
    { year: 36, percent: 62 },
    { year: 37, percent: 64 },
    { year: 38, percent: 66 },
    { year: 39, percent: 68 },
    { year: 40, percent: 70 },
    { year: 41, percent: 72 },
    { year: 42, percent: 74 },
    { year: 43, percent: 76 },
];

export const bm_type2: depreciation[] = [
    { year: 1, percent: 2 },
    { year: 2, percent: 4 },
    { year: 3, percent: 6 },
    { year: 4, percent: 8 },
    { year: 5, percent: 10 },
    { year: 6, percent: 14 },
    { year: 7, percent: 18 },
    { year: 8, percent: 22 },
    { year: 9, percent: 26 },
    { year: 10, percent: 30 },
    { year: 11, percent: 34 },
    { year: 12, percent: 38 },
    { year: 13, percent: 42 },
    { year: 14, percent: 46 },
    { year: 15, percent: 50 },
    { year: 16, percent: 55 },
    { year: 17, percent: 60 },
    { year: 18, percent: 65 },
    { year: 19, percent: 70 },
    { year: 20, percent: 75 },
    { year: 21, percent: 80 }
];

export const bm_type3: depreciation[] = [
    { year: 1, percent: 3 },
    { year: 2, percent: 6 },
    { year: 3, percent: 9 },
    { year: 4, percent: 12 },
    { year: 5, percent: 15 },
    { year: 6, percent: 20 },
    { year: 7, percent: 25 },
    { year: 8, percent: 30 },
    { year: 9, percent: 35 },
    { year: 10, percent: 40 },
    { year: 11, percent: 45 },
    { year: 12, percent: 50 },
    { year: 13, percent: 55 },
    { year: 14, percent: 60 },
    { year: 15, percent: 65 },
    { year: 16, percent: 72 },
    { year: 17, percent: 79 },
    { year: 18, percent: 86 }
];

export class Building {
    bid?: number;
    annual?: number;
    b_code?: string;
    ref_lid?: number;
    ref_luid?: number;
    oid?: number;
    parcel_code?: string;
    b_type?: number;
    b_material?: number;
    build_year?: number;
    address?: string;
    moo?: string;
    village?: string;
    width?: number;
    length?: number;
    no_floor?: number;
    no_room?: number;
    all_area: number=0;
    build_area?: number;
    main_home?: number;
    price_per_meter?: number;
    net_b_price?: number;
    depreciation?: number;
    depreciation_price?: number;
    road?: string;
    soi?: string;
    notes?: string;
    uid?: string;
    create_at: Date;
    modify_at: Date;

    constructor() {

    }
}

export class Bu {
    buid?: number;
    bid?: number;
    who_used?: number;
    used_type?: number;
    full_area_check?: number;
    floor_no?: string;
    width?: number;
    length?: number;
    area?: number;
    notes?: string;

    constructor() {

    }
}
